import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import DetailsComponent from "../../components/DetailsComponent";
import { getApi } from '../../api/endpoints.js';
import Cluster from '../../models/Cluster.js';
import { toast } from 'react-toastify';

const Show = () => {
  const [clusterDetails, setClusterDetails] = useState(new Cluster().toStateJson());
  const [fetchApi] = getApi('showCluster');
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setClusterDetails((new Cluster(response.data.cluster)).toStateJson());
    } catch (error) {
      toast.error(error?.data?.message || 'Something went wrong !');
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowClusterPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Cluster', url: '/clusters'}, { label: "Details" }]}
    className={'view-cluster-details-page'}
    >
  <PageContentWrapper contentHeading={'Cluster Details'}>
    <DetailsComponent data={clusterDetails} />
  </PageContentWrapper>
</Page>
};

export default Show;
